import { Button } from 'antd';
import { ReactNode } from 'react';
import {
  FallbackProps,
  ErrorBoundary as ReactErrorBoundary,
} from 'react-error-boundary';

const ErrorBoundary = ({ children }: { children: ReactNode }) => {
  function fallbackRender({ error, resetErrorBoundary }: FallbackProps) {
    console.error(error);
    return (
      <div className="w-full flex flex-col items-center">
        <p>Terjadi kesalahan pada server.</p>
        <Button onClick={resetErrorBoundary} type="primary" size="large">
          Coba lagi
        </Button>
      </div>
    );
  }

  return (
    <ReactErrorBoundary fallbackRender={fallbackRender}>
      {children}
    </ReactErrorBoundary>
  );
};

export default ErrorBoundary;
